<template>
  <el-tooltip :placement="placement" :popper-class="$popperClass" v-bind="$attrs">
    <i :style="{ fontSize: `${size}px` }" class="qm-icon-question qm-explain__icon" />
  </el-tooltip>
</template>

<script>
export default {
  name: 'QmExplain',
  props: {
    placement: {
      type: String,
      default: 'top',
      validator(value) {
        return (
          [
            'top',
            'top-start',
            'top-end',
            'bottom',
            'bottom-start',
            'bottom-end',
            'left',
            'left-start',
            'left-end',
            'right',
            'right-start',
            'right-end',
          ].indexOf(value) !== -1
        )
      },
    },
    size: {
      type: Number,
      default: 16,
    },
    popperClass: {
      type: String,
      default: 'qm-explain__tooltip',
    },
  },
  computed: {
    $popperClass() {
      if (this.popperClass === 'qm-explain__tooltip') {
        return 'qm-explain__tooltip'
      } else {
        return `qm-explain__tooltip ${this.popperClass}`
      }
    },
  },
}
</script>
